module.exports = __webpack_public_path__ + "media/images/premium/premium-frame-163a355870e8355331de186c384915a1.svg";